import { Row } from "v2/components/base/Flex/ui";

const SkeletonBar = ({
  isLoading,
  skeletonHeight,
  skeletonWidth,
  children,
  ...props
}: {
  isLoading: boolean;
  skeletonHeight: number | string;
  skeletonWidth: number | string;
  children: React.ReactNode;
} & any) => {
  const { sx, ...rest } = props;
  if (!isLoading) {
    return children;
  }

  return (
    <Row
      sx={{
        "@keyframes skeleton-loading": {
          "0%": { backgroundPosition: "100% 50%" },
          "100%": { backgroundPosition: "0 50%" },
        },
        width: skeletonWidth,
        height: skeletonHeight,
        borderRadius: 4,
        background: "linear-gradient(90deg, #eee 25%, #aaa 37%, #eee 63%)",
        backgroundSize: "400% 100%",
        animation: "skeleton-loading 1.4s ease infinite",
        ...sx,
      }}
      {...rest}
    />
  );
};

export default SkeletonBar;
